import React from 'react';
import { motion } from 'framer-motion';
interface BonusCardProps {
  number: string;
  title: string;
  image?: string;
  description: string;
  value: string;
  originalPrice: string;
  delay?: number;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  delay = 0
}: BonusCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative flex h-full min-h-[270px] flex-col rounded-2xl border border-purple-100 bg-[#fffdfa] p-3 shadow-[0_6px_16px_-12px_rgba(76,29,149,0.25)] sm:min-h-[310px] sm:p-4" data-id="element-100" data-mp="2x508po5kgc2i">
      <span className="absolute left-3 top-3 z-10 rounded-full bg-purple-950 px-2 py-1 text-[9px] font-black tracking-[0.08em] text-white" data-id="element-101" data-mp="2e6w8xkbkjpdd">
        {number}
      </span>
      {image && <motion.div initial={{
      opacity: 0,
      scale: 0.97
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      amount: 0.15
    }} transition={{
      duration: 0.65,
      ease: [0.22, 1, 0.36, 1]
    }} className="flex aspect-square shrink-0 items-center justify-center overflow-hidden rounded-xl bg-[#fff8ec] p-2" data-id="element-102" data-mp="1lorzj3vmq2hv">
          <img src={image} alt={title} className="h-full w-full object-contain" data-id="element-103" data-mp="1id8f7t5v4yow" />
        </motion.div>}
      <div className="mt-3 flex flex-1 flex-col" data-id="element-104" data-mp="1ddvwnkm0yds4">
        <span className="h-[22px] w-fit rounded-full bg-amber-50 px-2 py-1 text-[8px] font-black uppercase tracking-[0.08em] text-amber-800" data-id="element-105" data-mp="1dfp2wysq6vzl">
          Incluido gratis
        </span>
        <h3 className="mt-2 font-magical text-[17px] font-bold leading-[1.05] text-purple-950 sm:text-xl" data-id="element-106" data-mp="14e8s4py00ruu">
          {title}
        </h3>
        <p className="mt-2 text-[11px] leading-snug text-purple-950/70 sm:text-xs" data-id="element-107" data-mp="zggynrhpgxoj">
          {description}
        </p>
      </div>
    </motion.article>;
}